// Path redirect configuration: [pathPattern, externalUrl]
// pathPattern can be exact match or start with a path prefix
export const REDIRECT_CONFIG = new Map<string, string>([
    ['/scamnetic', 'https://www.nab.com.au/about-us/security/online-safety-tips'],
    ['/nab-carbon-insight-tool', 'https://www.nab.com.au/about-us/sustainability/environment/climate-change']
]);

// Default redirect URL when no path matches
export const DEFAULT_REDIRECT_URL = 'https://nab.com.au';
